var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-callout", { attrs: { controlled: "", "has-toggle": false } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            {
              class: `row d-flex align-items-center py-2 pr-3 ${
                _vm.checkable ? "col-11" : "col-12"
              }`
            },
            [
              _c("div", { staticClass: "col-12 col-md-4" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Centro:")]),
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm._f("empty")(_vm.value.center?.name)) + " "
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Municipio:")]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.municipality?.name)))
                ])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Lugar de Servicio:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(_vm.value.location?.name)))
                ])
              ]),
              _c(
                "div",
                { staticClass: "col-12 col-md-2 d-flex justify-content-end" },
                [_c("drop-down", { attrs: { items: _vm.actions } })],
                1
              ),
              _c("div", { staticClass: "w-100 px-3" }, [_c("hr")]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Total de Servicios:")
                ]),
                _c("div", [_vm._v(_vm._s(_vm._f("empty")(_vm.value.count)))])
              ])
            ]
          ),
          _vm.checkable
            ? _c(
                "div",
                {
                  staticClass:
                    "col row align-items-center justify-content-center"
                },
                [
                  _c(
                    "div",
                    [
                      _c("check-box", {
                        staticClass: "checkbox flex-grow-1",
                        model: {
                          value: _vm.value.checked,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "checked", $$v)
                          },
                          expression: "value.checked"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }